import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'drfSmgCompanyCustomer',
  props: {
    companyConfig: {
      type: Object,
      default: function _default() {
        return {
          accountConfig: {
            company_code: '',
            rule_type: ''
          },
          channelConfig: {
            company_code: ''
          },
          list: []
        };
      }
    },
    edit: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  watch: {
    companyConfig: {
      handler: function handler(newVal) {
        if (newVal) {
          this.handleInit();
        }
      },
      deep: true,
      immediate: true
    }
  },
  data: function data() {
    return {
      company_code: '',
      rule_type: '',
      list: [{
        name: '默认规则',
        id: 0
      }, {
        name: '个性化',
        id: 1
      }]
    };
  },
  computed: {
    isCompanyCodeDisabled: function isCompanyCodeDisabled() {
      return this.rule_type === 0;
    },
    currentCategoryName: function currentCategoryName() {
      var _this = this;
      var selectedCompany = this.companyConfig.list.find(function (item) {
        return item.company_code === _this.company_code;
      });
      return (selectedCompany === null || selectedCompany === void 0 ? void 0 : selectedCompany.category_name) || '';
    }
  },
  mounted: function mounted() {},
  methods: {
    handleInit: function handleInit() {
      var _this$companyConfig = this.companyConfig,
        accountConfig = _this$companyConfig.accountConfig,
        channelConfig = _this$companyConfig.channelConfig;
      this.rule_type = accountConfig.rule_type;
      if (this.rule_type === 0) {
        // 默认规则 从渠道配置获取
        this.company_code = channelConfig.company_code;
      } else if (this.rule_type === 1) {
        // 个性化 从账号配置获取
        this.company_code = accountConfig.company_code;
      }
    },
    changeType: function changeType() {
      var _this$companyConfig2 = this.companyConfig,
        accountConfig = _this$companyConfig2.accountConfig,
        channelConfig = _this$companyConfig2.channelConfig;
      if (this.rule_type === 0) {
        this.company_code = channelConfig.company_code;
      } else if (this.rule_type === 1) {
        // 个性化 从账号配置获取
        this.company_code = accountConfig.company_code;
      }
    }
  }
};